export default "__VITE_ASSET__dfe540dd__"